<template>
  <main-layout class="main-layout">
    <div slot="left-side">
      <menubar v-if="this.flag == '01'" screenIdParam="M-05-04-01"></menubar>
      <menubar v-else screenIdParam="M-05-04-02"></menubar>
    </div>

    <!--   ヘッダー行の開始   -->
    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">
          <label v-if="this.flag == '01'" class="margin-left-label">
            {{this.$t('label.system.setting.notification.point_notification_settings')}}</label
          >
          <label v-else class="margin-left-label">
            {{this.$t('label.system.setting.notification.concierge_notification_settings')}}</label
          >
        </label>

        <lvory-but
          @click="goback"
          slot="cancel">
          {{this.$t('button.common.cancel')}}
        </lvory-but>

        <narrow-down slot="create" @click="saveSettingNotification" >{{ $t("button.common.data.save") }}</narrow-down>
      </headTitle>
    </el-row>

    <!--  メインページ開始  -->
    <div slot="body" class="text-color" v-show="contentDisplay">
      <el-form :model="result">
        <el-form-item>
          <div
            v-for="(item, i) in result.query"
            :key="i"
            class="div-size">
            <el-row class="m-bottom-2">
              <span class="font-size-16">
                {{ $t("label.system.setting.notification." + item.item) }}
              </span>
              <span v-for="(m, index) in item.methodList" :key="index">
                <span
                  v-if="index == 0"
                  class="span-size">
                  <el-switch v-model="m.enable"> </el-switch>
                </span>
                <span v-else class="span-size">
                  <el-switch v-model="m.enable" class="margin-left-100">
                  </el-switch>
                </span>
              </span>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
      <el-row class="margin-left-body">
        <narrow-down @click="saveSettingNotification" >{{ $t("button.common.data.save") }}</narrow-down>
      </el-row>

      <loading-dialog :dialogVisible="showLoading" />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam"
      >
       </el-dialog-prompt>

    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import headTitle from "@/components/common/head/head"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import elDialogPrompt from "@/components/common/el-dialog-prompt"

export default {
  name: "ConciergeTop",
  components: {
    MainLayout: NewDesignLayout,
    Menubar: Menubar,
    LoadingDialog: LoadingDialog,
    LvoryBut:LvoryBut,
    headTitle:headTitle,
    elDialogPrompt,
    narrowDown:narrowDown
  },
  data() {
    return {
      msgParam: this.$t("message.common.validation.updateMessageNew", {
        field: this.$t("label.system.setting.notification.setting"),
      }),
      showLoading: false,
      centerDialogVisibleIsShow: false,
      result: {
        query: [
        ],
      },
      flag: null,
      methodSecond: [
        {
          code: null,
          enable: null,
        },
      ],
    };
  },
  computed: {
    contentDisplay() {
      return this.result.query.length > 0;
    }
  },
  methods: {
    forList() {
      if (this.flag == "01") {
        //ポイント各通知設定取得兼全マスタ取得
        SystemManageApi.PointNotificationPageInit().then(({ data }) => {
          this.notificationPageInit(data);
        });
      } else {
        //ヘルプデスク各通知設定取得兼全マスタ取得
        SystemManageApi.HelpNotificationPageInit().then(({ data }) => {
          this.notificationPageInit(data);
        });
      }
    },
    notificationPageInit(value) {
      this.result.query = [];
      for (let items of value.body) {
        this.methodSecond = [];
        for (let methodCode of items.methodList) {
          this.methodSecond.push({
            code: methodCode.code,
            enable: methodCode.enable,
          });
        }
        this.result.query.push({
          item: items.item,
          methodList: this.methodSecond,
        });
      }
    },
    saveSettingNotification() {
      this.centerDialogVisibleIsShow = true;
    },

    isPassParam(param) {
      if (param) {
        this.doneSaveSettingNotification();
      }
    },

    doneSaveSettingNotification() {
      this.centerDialogVisibleIsShow = false;
      this.showLoading = true;
      if (this.flag == "01") {
        //ポイント各通知設定変更
        SystemManageApi.PointNotificationSetting(this.result.query
        ).then(() => {
          this.saveSuccess();
        }).finally(()=>{
          this.showLoading = false
        });
      } else {
        //アカウント各通知設定変更
        SystemManageApi.HelpNotificationSetting(this.result.query
        ).then(() => {
          this.saveSuccess();
        }).finally(()=>{
          this.showLoading = false
        });
      }
    },

    //保存成功Message
    saveSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.saveSuccess", {
        field: this.$t("label.system.setting.notification.settings"),
      }));
    },
    goback(){
      this.$router.push({
        name:"system-setting-various"
      })
    }
  },
  created() {
    this.flag = this.$route.query.flag == undefined ? this.$route.meta.flag : this.$route.meta.flag;
    this.forList();
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: this.flag == '01' ? "label.router.pointNotification" : "label.router.conciergeNotification",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)

  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.main-layout{
  .div-size{
    width: 375px;
  }
  .span-size{
    float: right;
    margin-right: 25px;
  }
  .font-size-16{
    font-size: 16px;
  }


  .margin-left-100 {
    margin-left: 104px;
  }
  // ::v-deep.el-switch {
  //   width: 53px;
  //   height: 28px;
  // }
  // .el-switch >>> .el-switch__core {
  //   height: 28px !important;
  //   display: block !important;
  //   border-radius: 14px;
  // }
  // .el-switch >>> .el-switch__core:after {
  //   width: 24px !important;
  //   height: 24px !important;
  // }

  ::v-deep .el-switch.is-checked .el-switch__core::after {
    left: 100%;
  }
  .width-size {
    width: 80px;
    height: 42px;
  }
  .margin-left-label {
    margin-left: 16px;
  }
  .margin-top-label {
    margin-top: 67px;
  }
  .el-form-item >>> .el-form-item__content {
    line-height: 52px !important;
    font-size: 16px !important;
  }
  ::v-deep.layout main .body {
    padding: 21px;
    flex-grow: 1;
  }
  .margin-left-body {
    margin-top: 52px;
  }
}

.text-color {
  color: #525250;
}

::v-deep .div-size:nth-last-of-type(1) .m-bottom-2 {
  margin-bottom: 0px !important;
}

::v-deep .el-form-item__content {
  line-height: 32px !important;
}
</style>
